/**
 * @file     index.tsx
 * @purpose  404 view on SystemPage: error-code eyebrow, H1, one line, the
 *           address search as the next action and six crawlable hub links.
 */
'use client';

import dynamic from 'next/dynamic';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { SystemPage } from '@/views/system/SystemPage';

// The root not-found chunk ships with every page (for client-side notFound()),
// so the search box and its city table load only when a 404 actually renders.
const HeroSearchBar = dynamic(() => import('@/components/search/HeroSearchBar').then((m) => m.HeroSearchBar));

const NotFoundView = () => {
  const { t } = useTranslation();

  const links = [
    { label: t('notFound.popular.bc', { defaultValue: 'Homes for sale in British Columbia' }), href: '/british-columbia' },
    { label: t('notFound.popular.vancouver', { defaultValue: 'Homes for sale in Vancouver, BC' }), href: '/properties/vancouver' },
    { label: t('notFound.popular.mortgage', { defaultValue: 'Mortgage calculator' }), href: '/mortgage-calculator' },
    { label: t('notFound.popular.homeWorth', { defaultValue: 'What is my home worth' }), href: '/what-is-my-home-worth' },
    { label: t('notFound.popular.marketReport', { defaultValue: 'Vancouver market report' }), href: '/market-report/vancouver' },
    { label: t('notFound.popular.learn', { defaultValue: 'Learn about BC real estate' }), href: '/learn-about-bc-real-estate' },
  ];

  return (
    <SystemPage
      eyebrow={t('notFound.eyebrow', { defaultValue: 'Error 404' })}
      title={t('notFound.headline', 'Page not found')}
      description={t('notFound.body', 'This page does not exist or has moved.')}
      actionSlot={
        <Box sx={{ width: '100%', maxWidth: 520 }}>
          <HeroSearchBar
            tone="light"
            placeholder={t('notFound.searchPlaceholder', { defaultValue: 'Address, MLS® number or city' })}
          />
        </Box>
      }
      links={links}
      linksTitle={t('notFound.popularTitle', { defaultValue: 'Popular pages' })}
    />
  );
};

export default NotFoundView;
